import {
  Badge,
  Box,
  Button,
  FormControl,
  Image,
  Input,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { Icon, Img } from "../../../../content/Content";
import { AiOutlinePlus } from "react-icons/ai";
import '../Chat.component.css'
const LeftChat = () => {
  const contactData = [
    {
      avatar: Img.avatar1,
      name: "Ronald",
      message: "it is a long establish fact",
      time1: "Des 12 2023",
      time2: "10:00 AM",
      status: true,
    },
    {
      avatar: Img.avatar2,
      name: "Cameron",
      message: "it is a long establish fact",
      time1: "Des 12 2023",
      time2: "10:00 AM",
      status: false,
    },
    {
      avatar: Img.avatar3,
      name: "Shawn",
      message: "it is a long establish fact",
      time1: "Des 12 2023",
      time2: "10:00 AM",
      status: false,
    },
    {
      avatar: Img.avatar4,
      name: "Leslie",
      message: "it is a long establish fact",
      time1: "Des 12 2023",
      time2: "10:00 AM",
      status: false,
    },
  ];

  const GroupData = [
    {
      avatar: "",
      name: "Forex Agency",
      time1: "Des 12 2023",
      time2: "10:00 AM",
      avatrText:"FRX",
      color:"#92E0CD",
      colorText:"#21997C",
      status: true,
      groupPhoto: [
        {
          g1: Img.PostAvatar1,
          left:"-18px",
          zIndex: 0
        },
        {
          g1: Img.PostAvatar2,
          left:"-6px",
          zIndex:5
        },

      ],
    },
    {
      avatar: "",
      name: "ABC Group",
      message: "it is a long establish fact",
      time1: "Des 12 2023",
      time2: "10:00 AM",
      avatrText:"ABC",
      color:"#B492E0",
      colorText:"#5E29A0",
      status: false,
      groupPhoto: [
        {
          g1: Img.PostAvatar1,
          left:"-18px",
          zIndex: 0
        },
        {
          g1: Img.PostAvatar2,
          left:"-6px",
          zIndex:5
        },

      ],
    },
    {
      avatar: "",
      name: "Forex Agency",
      message: "it is a long establish fact",
      time1: "Des 12 2023",
      time2: "10:00 AM",
      status: false,
      avatrText:"FRX",
      color:"#F4F66E",
      colorText:"#B8BB10",
      groupPhoto: [
        {
          g1: Img.PostAvatar1,
          left:"-18px",
          zIndex: 0
        },
        {
          g1: Img.PostAvatar2,
          left:"-6px",
          zIndex:5
        },

      ],
    },
    {
      avatar: "",
      name: "BRQ",
      message: "it is a long establish fact",
      time1: "Des 12 2023",
      time2: "10:00 AM",
      status: false,
      avatrText:"FRX",
      color:"#5BA3E4",
      colorText:"#317DC2",
      groupPhoto: [
        {
          g1: Img.PostAvatar1,
          left:"-18px"
        },
        {
          g1: Img.PostAvatar2,
          left:"-6px"
        },

      ],
    },    
    {
      avatar: "",
      name: "Forex Agency",
      message: "it is a long establish fact",
      time1: "Des 12 2023",
      time2: "10:00 AM",
      status: false,
      avatrText:"FRX",
      color:"#92E0CD",
      colorText:"#21997C",
      groupPhoto: [
        {
          g1: Img.PostAvatar1,
          left:"-18px",
          zIndex: 0
        },
        {
          g1: Img.PostAvatar2,
          left:"-6px",
          zIndex:5
        },

      ],
    },
  ];
  return (
    <VStack w="100%">
      <Stack bg="#FFFFFF" p="25px 35px" borderRadius="18px" w="100%">
        <FormControl>
          <Input
            type="text"
            placeholder="Search contact"
            w="100%"
            px="25px"
            h="52px"
            borderRadius="8px"
            border="none"
            bg="#F5F5FF"
            fontFamily="'Roboto',sans-serif"
            fontSize="16px"
            fontWeight="400"
            color="#9597AB"
            _placeholder={{
              fontFamily: "'Roboto',sans-serif",
              fontSize: "16px",
              fontWeight: "400",
              color: "#9597AB",
            }}
          />
        </FormControl>

        <Stack>
          {contactData.map((item) => (
            <Stack flexDir="row" w="100%" py="15px">
              <Box
                w="85%"
                display="flex"
                flexDir="row"
                justifyContent="space-between"
                alignItems="flex-start"
              >
                <Image src={item.avatar} h="47px" w="47px" />
                <Box >
                  <Text
                    fontFamily="'Roboto',sans-serif"
                    fontSize="20px"
                    fontWeight="500"
                  >
                    {item.name}
                  </Text>
                  <Text
                    fontFamily="'Roboto',sans-serif"
                    fontSize="16px"
                    fontWeight="400"
                    color="#9597AB"
                    pt="5px"
                  >
                    {item.message}
                  </Text>
                  <Text
                    display="flex"
                    flexDir="row"
                    fontFamily="'Roboto',sans-serif"
                    fontSize="16px"
                    fontWeight="400"
                    pt="5px"
                  >
                    {item.time1}
                    <Text mx="10px">{item.time2}</Text>
                  </Text>
                </Box>
              </Box>
              <Box
                w="15%"
                display="flex"
                flexDir="column"
                justifyContent="space-between"
                alignItems="flex-end"
              >
                {item.status ? (
                  <Badge
                    bg="red"
                    color="#fff"
                    borderRadius="20px"
                    h="20px"
                    w="20px"
                    justifyContent="center"
                    alignItems="center"
                    display="flex"
                  >
                    1
                  </Badge>
                ) : (
                  ""
                )}

                <Box>
                  <Image
                    src={item.status ? Icon.greenCheck : Icon.normalCheck}
                    w="22px"
                    h="22px"
                  />
                </Box>
              </Box>
            </Stack>
          ))}
        </Stack>
      </Stack>

      {/* group Chat */}
      <Stack bg="#FFFFFF" p="25px 35px" borderRadius="18px" w="100%" my="20px">
        <Stack>
          <Stack flexDir="row" justifyContent="space-between" py="10px">
            <Box>
              <Text
                fontFamily="'Roboto', sans-serif"
                fontSize="20px"
                fontWeight="500"
              >
                Group (5)
              </Text>
            </Box>
            <Box >
              <Button fontSize="20px" p={"0"} bg="transparent">
                <AiOutlinePlus />
              </Button>
            </Box>
          </Stack>
          {GroupData.map((item, id) => (
            <Stack flexDir="row" w="100%" py="15px" key={id}>
              <Box
                w="85%"
                display="flex"
                flexDir="row"
                justifyContent="space-between"
                alignItems="flex-start"
              >
                {
                  item.avatar==="" ? <Box w="49px" display="flex" alignItems="center" justifyContent="center" h="49px" borderRadius="8px" bg={item.color} color={item.colorText}>{item.avatrText}</Box>:<Image src={item.avatar} h="47px" w="47px" />
                }
                <Box>
                  <Text
                    fontFamily="'Roboto',sans-serif"
                    fontSize="20px"
                    fontWeight="500"
                  >
                    {item.name}
                  </Text>
                  <Text
                    display="flex"
                    flexDir="row"
                    fontFamily="'Roboto',sans-serif"
                    fontSize="16px"
                    fontWeight="400"
                    pt="5px"
                  >
                    {item.time1}
                    <Text mx="10px">{item.time2}</Text>
                  </Text>
                </Box>
              </Box>
              <Box w="15%" display="flex" flexDir="row" alignItems="flex-start" position="relative">
                {item.groupPhoto.map((sm, id) => (
                  <Box key={id} position="absolute" left={sm.left}>
                    <Image
                      src={sm.g1}
                      w="20px"
                      h="20px"
                      border="2px solid #fff"
                      borderRadius="10px"

                    />
                  </Box>
                ))}
              </Box>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </VStack>
  );
};

export default LeftChat;
